import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicRegularExpressions = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Regular Expressions in TOC"
      videos={[
        "https://www.youtube.com/embed/4C7ZQJDoK-g",
        "https://www.youtube.com/embed/LQ6pHeMG6Fc",
      ]}
      takeaways={[
        { text: "Learn the definition and properties of regular expressions." },
        { text: "Learn how to design regular expressions properly." },
      ]}
      questions={[

      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicRegularExpressions };
